import { BlocksIconShopFilled } from 'blocks-nextjs/blocks-web-components/components/icon/icons/shop-filled';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconShopFilled = createComponent({ react: React, tagName: 'cat-icon-shop-filled', elementClass: BlocksIconShopFilled });
